import React, { Component, push } from "react";
import { withRouter } from "react-router-dom";
import {
  Grommet,
  Box,
  Accordion,
  AccordionPanel,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Layer,
  Spinner,
  //Notification,
  //Notification,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Console,
  // Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  StatusGood,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Close,
  MoreVertical,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
//import { showToast } from "../common/UtilityHelper";
//import Canceldemo from "./Canceldemo";
import auth from "./Security/Auth";
import {
  callApiGetJson,
  callApiPostJson,
  APIServerURL,
  logAccess,
  debugLog,
} from "./GlobalSettings";
//import StaticTypeDemoDisplay from "./StaticTypeDemoDisplay";
//import { Event } from "@material-ui/icons";
//import UpdateExtensionMessage from "./UpdateExtensionMessage";
//import ExtendDemoQuestion from "./ExtendDemoQuestion";
//import StaticClickDemoFrame from "./StaticClickDemoFrame";
//import TMEAddSeatsOverlay from "./TMEAddSeatsOverlay";
import Alert from "@material-ui/lab/Alert";
//import { Alert } from "@material-ui/core";
import { isThisSecond } from "date-fns";
import EvtAprAddInfoPopup from "./EvtAprAddInfoPopup";
//import TmeCRSeatlst from "./TmeCRSeatlst";
//import DemoLaunchInfo from "./DemoLaunchInfo";

class EvtsForApprovals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bdispCancel: false,
      UserInfo: auth.getUserInfo(),
      UserActions: auth.getUserActions(),
      demoType: "",
      demosTBApproved: this.props.Evt,
      showAprLoader: false,
      showDenLoader: false,
      disableAprSubmit: false,
      disableDenSubmit: false,
      isApproved: false,
      isDenied: false,
      openAddInfoEvt: false,
    };

    //this._ShowCancel = this._ShowCancel.bind(this);
    this._hanldeApprovalClick = this._hanldeApprovalClick.bind(this);
    this._hanldeDenialClick = this._hanldeDenialClick.bind(this);
    this.hidePop = this.hidePop.bind(this);
    this.hideAll = this.hideAll.bind(this);
    this.handleCallback = this.handleCallback.bind(this);
  }

  componentDidMount() {
    // this._loadVRNetLaunchInfo();
  }

  componentWillUnmount() {
    //clearInterval(this._evtInterval);
  }

  /*  _ShowCancel() {
    this.setState({ bdispCancel: true });
  } */

  _hanldeApprovalClick() {
    console.log("Approval Clicked");

    if (
      this.props.Evt.Env_Type === "TME-LAB" ||
      this.props.Evt.Env_Type === "EDGELINE" ||
      this.props.Evt.Env_Type === "STATIC-TYPE" ||
      this.props.Evt.Env_Type === "TME_INDIVIDUAL" ||
      this.props.Evt.Env_Type === "TME_CLASSROOM"
    ) {
      this.setState({ openAddInfoEvt: true });
    } else {
      var evtAprData = {
        EventId: this.state.demosTBApproved.Event_ID,
        Status: "Approved",
        IsAdditionalInfoType:
          this.props.Evt.Env_Type === "TME-LAB" ||
          this.props.Evt.Env_Type === "EDGELINE" ||
          this.props.Evt.Env_Type === "STATIC-TYPE" ||
          this.props.Evt.Env_Type === "TME_INDIVIDUAL" ||
          this.props.Evt.Env_Type === "TME_CLASSROOM"
            ? true
            : false,
        Url: null,
        Uid: null,
        Pwd: null,
        Realm: null,
      };

      var endpoint = "/Events/ApproveDenyEvent";
      let token = auth.getToken();
      var postData = evtAprData;
      console.log("Event Approval request data for Update :", postData);
      this.setState({
        showAprLoader: true,
        disableAprSubmit: true,
        disableDenSubmit: true,
      });
      //start below
      callApiPostJson(endpoint, postData, token).then((data) => {
        console.log("Approval Event result data from API:", data);
        if (data) {
          console.log("UpdateMessage: ");
          console.log(data);
          this.setState({ showAprLoader: false, isApproved: true });
          // this.props.history.push("/home");
          //this.props.router.replace("/home");
        }
      });
    }
  }

  _hanldeDenialClick() {
    console.log("Denial Clicked");

    var evtDenData = {
      EventId: this.state.demosTBApproved.Event_ID,
      Status: "Denied",
      IsAdditionalInfoType:
        this.props.Evt.Env_Type === "TME-LAB" ||
        this.props.Evt.Env_Type === "EDGELINE" ||
        this.props.Evt.Env_Type === "STATIC-TYPE" ||
        this.props.Evt.Env_Type === "TME_INDIVIDUAL" ||
        this.props.Evt.Env_Type === "TME_CLASSROOM"
          ? true
          : false,
      Url: null,
      Uid: null,
      Pwd: null,
      Realm: null,
    };

    var endpoint = "/Events/ApproveDenyEvent";
    let token = auth.getToken();
    var postData = evtDenData;
    console.log("Event Denial request data for Update :", postData);
    this.setState({
      showDenLoader: true,
      disableAprSubmit: true,
      disableDenSubmit: true,
    });
    //start below
    callApiPostJson(endpoint, postData, token).then((data) => {
      console.log("Denial Event result data from API:", data);
      if (data) {
        console.log("UpdateMessage: ");
        console.log(data);
        this.setState({ showDenLoader: false, isDenied: true });
        // this.props.history.push("/home");
        //this.props.router.replace("/home");
      }
    });
  }

  hidePop() {
    this.setState({ openAddInfoEvt: false });
  }
  hideAll() {
    this.props.hide();
  }

  handleCallback(cval) {
    console.log("Callback called with value ", cval);
    if (cval) {
      this.setState({
        isApproved: true,
        disableAprSubmit: true,
        disableDenSubmit: true,
      });
    }
  }

  render() {
    //this.reLoadEventBasics();
    var _Evt = this.props.Evt;

    var startDateObject = _Evt.Event_StartDate
      ? new Date(_Evt.Event_StartDate)
      : null;
    var endDateObject = _Evt.Event_EndDate
      ? new Date(_Evt.Event_EndDate)
      : null;

    return (
      <Accordion>
        {this.state.openAddInfoEvt && (
          <EvtAprAddInfoPopup
            EvtData={_Evt}
            hide={this.hidePop}
            hideAll={this.hideAll}
            callback={this.handleCallback}
          />
        )}
        <AccordionPanel label={_Evt.Event_ID + " - " + _Evt.Event_Title}>
          <Card
            direction="column"
            pad="medium"
            background={{ color: "background" }}
          >
            <Box align="stretch" justify="start">
              <Box align="stretch" justify="start" direction="column">
                <Grid
                  columns={["small", "medium"]}
                  gap="xxsmall"
                  align="start"
                  justify="start"
                >
                  <Text>EventID</Text>
                  <Text>{_Evt.Event_ID}</Text>
                  <Text>Event Subject</Text>
                  <Text>
                    <b>{_Evt.Event_Title}</b>
                  </Text>
                  <Text>When</Text>
                  <Text>
                    <b>
                      {startDateObject
                        ? startDateObject.toString()
                        : _Evt.Event_StartDate}
                    </b>
                  </Text>
                  <Text>Who</Text>
                  <Text>
                    <b>
                      <font color="green">
                        {_Evt.Event_Presenter.EmailAddress}
                      </font>
                    </b>
                  </Text>
                  <Text>Event Duration</Text>
                  <Text>
                    <b>{_Evt.Event_Duration.Duration_Name}</b>
                  </Text>
                  <Text>Event Status</Text>
                  <Text>
                    <b>
                      {this.state.isApproved
                        ? "Approved"
                        : this.state.isDenied
                        ? "Denied"
                        : _Evt.Event_Status.EventStatus_Name}
                    </b>
                  </Text>
                </Grid>
                <Box
                  align="start"
                  justify="between"
                  direction="row"
                  gap="small"
                  responsive={false}
                  pad="medium"
                >
                  <Button
                    label={
                      this.state.showDenLoader ? (
                        <Box
                          direction="row"
                          gap="small"
                          justify="center"
                          align="center"
                        >
                          <Spinner size="small" color="brand" />{" "}
                          <Text>Denying...</Text>
                        </Box>
                      ) : (
                        "Deny"
                      )
                    }
                    primary={true}
                    //secondary={true}
                    icon={<Clear color="Red" />}
                    onClick={this._hanldeDenialClick}
                    disabled={this.state.disableDenSubmit}
                  />

                  <Button
                    label={
                      this.state.showAprLoader ? (
                        <Box
                          direction="row"
                          gap="small"
                          justify="center"
                          align="center"
                        >
                          <Spinner size="small" color="brand" />{" "}
                          <Text>Approving...</Text>
                        </Box>
                      ) : (
                        "Approve"
                      )
                    }
                    // fill={true}
                    primary={true}
                    icon={<StatusGood color="black" />}
                    onClick={this._hanldeApprovalClick}
                    disabled={this.state.disableAprSubmit}
                  />
                </Box>
              </Box>
            </Box>
          </Card>
        </AccordionPanel>
      </Accordion>
    );
  }
}

export default EvtsForApprovals;
